document.addEventListener('DOMContentLoaded', function() {
  const openBtn = document.querySelector('.open-size-chart');
  const modal = document.getElementById('sizeChartModal');
  const closeBtn = document.querySelector('.close-size-chart');

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener('click', function(e) {
      e.preventDefault();
      modal.style.display = 'flex';
    });

    closeBtn.addEventListener('click', function() {
      modal.style.display = 'none';
    });

    window.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function() {
var sizechartnewbtn = document.querySelector('.open-size-chart');
var sizechartclosebtn = document.querySelector('div#sizeChartModal span.close-size-chart');
  if(sizechartnewbtn){
    sizechartnewbtn.addEventListener('click',function(){
    document.querySelector('safe-sticky.product-info').style.display="contents";
})
}
if(sizechartclosebtn){
sizechartclosebtn.addEventListener('click',function(){
    document.querySelector('safe-sticky.product-info').style.display="block";
})
}
});

document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
    function openchart() {
      // Wait until modal content is added to DOM
      var modalsizebtn = document.querySelector('.quick-buy-modal .open-size-chart');
      var closesizebtn = document.querySelector('.quick-buy-modal span.close-size-chart');
if (modalsizebtn) {
        modalsizebtn.addEventListener('click', function () {
          var modal = document.querySelector('.quick-buy-modal.modal  div#sizeChartModal');
         
            modal.style.display = "flex";
          
        });
}

      if (closesizebtn) {
        closesizebtn.addEventListener('click', function () {
          var modal = document.querySelector('.quick-buy-modal.modal div#sizeChartModal');
         
            modal.style.display = "none";
          
        });
      }
    }


  var allsectionlist = document.querySelectorAll('.shopify-section ');

  allsectionlist.forEach(function (section) {
      var quickallbtn = section.querySelectorAll('.product-card__quick-add-button');
    quickallbtn.forEach(function (quick) {
      quick.addEventListener('click', function () {
        // Delay to allow modal DOM to load
        setTimeout(function () {
          openchart();
        }, 1500);
      });
    });
    
  })
    }, 3000);
});

document.addEventListener("DOMContentLoaded", function() {
  var customTabsTitles = document.querySelectorAll('.product_size_chart_table_header_nav_item');
  if (customTabsTitles.length) {
    customTabsTitles.forEach(function(item) {
      item.addEventListener("click", function() {
        var customTabsBody = this.closest('.product_size_chart_table_wrapper').querySelectorAll('.product_size_chart_table');
        var customTabsTitlesCur = this.closest('.product_size_chart_table_wrapper').querySelectorAll('.product_size_chart_table_header_nav_item');
        var tableUnit = this.closest('.product_size_chart_table_wrapper').querySelector('.product_size_chart_table_header_unit');
        var currentId = this.getAttribute('data-id');
        customTabsTitlesCur.forEach(function(el) {
          el.classList.remove('active');
        });
        this.classList.add('active');
        if (tableUnit) {
          tableUnit.innerHTML = this.innerHTML;
        }
        if (customTabsBody.length) {
          customTabsBody.forEach(function(el) {
            if (currentId == el.getAttribute('data-id')) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          });
        }
      });
    });
  }
});
